var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPortfolio = function SvgPortfolio(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6001 3.8001L35.0001 0.600098H26.2001L23.8001 3.8001H0.600098V29.4001H36.6001V3.8001Z",
    stroke: "#99999F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4001 20.6001H10.6001",
    stroke: "#99999F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6002 15H12.2002V20.6H14.6002V15Z",
    stroke: "#99999F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7999 17.3999H23.3999V20.5999H25.7999V17.3999Z",
    stroke: "#99999F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1998 12.6001H17.7998V20.6001H20.1998V12.6001Z",
    stroke: "#99999F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.2,
    height: 30,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPortfolio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Portfolio.0d420437.svg";